import IOperator from "interfaces/IOperator";
import Dictionary from "utils/dictionary";

export interface IOperatorStoreState {
  operators?: Dictionary<IOperator[]>;
}

export const initialOperatorStoreState: IOperatorStoreState = {};
